import React from 'react';

import { CookieConsent } from './CookieConsent';
import { CookiePolicyReminderBanner } from './CookiePolicyReminderBanner';

export const CookieBanners = () => (
  <>
    <CookieConsent />
    <CookiePolicyReminderBanner />
  </>
);
